export const reorderItems = (items, fromIndex, toIndex) => {
  const nextItems = [...items];
  const [removed] = nextItems.splice(fromIndex, 1);
  nextItems.splice(toIndex, 0, removed);
  return nextItems;
};

export const buildMovePayload = (items, fromIndex, toIndex, getItemId = (item) => item.uid) => {
  if (fromIndex === toIndex) return null;

  const uid = getItemId(items[fromIndex]);

  if (!uid) {
    return null;
  }

  const nextItems = reorderItems(items, fromIndex, toIndex);
  const movedIndex = nextItems.findIndex((item) => getItemId(item) === uid);

  const nextItem = nextItems[movedIndex + 1];
  if (nextItem) {
    const beforeUid = getItemId(nextItem);
    return beforeUid ? { uid, before: beforeUid } : null;
  }

  const previousItem = nextItems[movedIndex - 1];
  if (previousItem) {
    const afterUid = getItemId(previousItem);
    return afterUid ? { uid, after: afterUid } : null;
  }

  return null;
};

export const applyMovePayload = (items, move, getItemId = (item) => item.uid) => {
  if (!move?.uid) return items;

  const fromIndex = items.findIndex((item) => getItemId(item) === move.uid);
  if (fromIndex === -1) return items;

  const movedItem = items[fromIndex];
  const remainingItems = items.filter((item) => getItemId(item) !== move.uid);

  let toIndex = remainingItems.length;

  if (move.before) {
    const beforeIndex = remainingItems.findIndex((item) => getItemId(item) === move.before);
    if (beforeIndex === -1) return items;
    toIndex = beforeIndex;
  } else if (move.after) {
    const afterIndex = remainingItems.findIndex((item) => getItemId(item) === move.after);
    if (afterIndex === -1) return items;
    toIndex = afterIndex + 1;
  }

  const nextItems = [...remainingItems];
  nextItems.splice(toIndex, 0, movedItem);
  return nextItems;
};
